module.exports = __webpack_public_path__ + "static/media/nf.7c6364a0.svg";